export default __webpack_public_path__ + "static/media/03-banner-25ANIVERSARIO.fb7d3575.jpg";